import { useEffect } from "react";

export const Redirect = ({ to }: { to: string }) => {
  useEffect(() => {
    history.replaceState(history.state, "", to);
  }, [to]);
  return null;
};
